import { render, staticRenderFns } from "./NewsFlashOverview.vue?vue&type=template&id=f4e2d388&scoped=true&"
import script from "./NewsFlashOverview.vue?vue&type=script&lang=js&"
export * from "./NewsFlashOverview.vue?vue&type=script&lang=js&"
import style0 from "./NewsFlashOverview.vue?vue&type=style&index=0&id=f4e2d388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e2d388",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCardText,VCarousel,VCarouselItem,VSheet})
